import React from 'react';

import { AuthenticationActivity } from 'activities/auth/AuthenticationActivity/AuthenticationActivity';
import { routeDirectory } from 'modules';
import { Route } from 'react-router-dom';

import { SuperAdminDashboardActivity } from './SuperAdminDashboardActivity/SuperAdminDashboardActivity';
import { UserProfileActivity } from './UserProfileActivity/UserProfileActivity';



export const routes = <>
  <Route
    path={routeDirectory.superAdmin.auth.rawPath}
    element={<AuthenticationActivity superAdmin />} />

  <Route
    path={routeDirectory.superAdmin.dashboard.rawPath}
    element={<SuperAdminDashboardActivity />} />

  <Route
    path={routeDirectory.superAdmin.profile.rawPath}
    element={<UserProfileActivity />} />
</>;
